import React, { memo } from 'react';
import PropTypes from 'prop-types';
import useSWR from 'swr';

import { expertApi } from 'src/api/expertApi';
import { TAB_CONFIG } from 'src/constants/config';
import { getPitchForExpert } from 'src/utils/queryUtils';
import useFormatDate from 'src/hooks/useFormatDate';
import ActivityTab from 'src/pages/QueryPages/QueryProfile/components/tabs/ActivityTab';
import ExpertSelectionTab from 'src/pages/QueryPages/QueryProfile/components/tabs/ExpertSelectionTab';
import EmailExpertTab from 'src/pages/QueryPages/QueryProfile/components/tabs/EmailExpertTab';
import SubmissionTab from 'src/pages/QueryPages/QueryProfile/components/tabs/SubmissionTab';
import SuccessfulPlacementTab from 'src/pages/QueryPages/QueryProfile/components/tabs/SuccessfulQueryTab';

const fetcher = () => expertApi.getExperts();

const TabContent = memo(({ activeTab, query, refetch, selectedExpert, setSelectedExpert, loading, handleExpertDirectoryClick }) => {
  const { data: experts } = useSWR('experts', fetcher);

  const formattedSentToExpertDate = useFormatDate(query?.sentToExpertDate);
  const formattedSentToReporterDate = useFormatDate(query?.sentToReporterDate);

  const getLeadId = () => {
    if (query?.status === 'draft' && selectedExpert) {
      const selectedLead = query.leads.find((lead) => Number(lead.expertID) === Number(selectedExpert.id));
      return selectedLead?.id;
    }
    return query.leads.find((lead) => lead.id === query?.emailSentOut)?.id;
  };

  switch (activeTab) {
    case TAB_CONFIG.ACTIVITY.id:
      return <ActivityTab formattedSentToExpertDate={formattedSentToExpertDate} formattedSentToReporterDate={formattedSentToReporterDate} />;
    case TAB_CONFIG.EXPERT.id:
      return (
        <ExpertSelectionTab
          query={query}
          experts={experts}
          refetch={refetch}
          selectedExpert={selectedExpert}
          setSelectedExpert={setSelectedExpert}
          loading={loading}
          handleExpertDirectoryClick={handleExpertDirectoryClick}
        />
      );
    case TAB_CONFIG.EMAIL.id:
      return <EmailExpertTab pitch={getPitchForExpert(query, selectedExpert?.id)} query={query} expert={selectedExpert} />;
    case TAB_CONFIG.SUBMIT.id:
      return <SubmissionTab leadID={getLeadId()} queryID={query.id} query={query} expert={selectedExpert} />;
    case TAB_CONFIG.SUCCESSFUL.id:
      return <SuccessfulPlacementTab queryID={query.id} query={query} expert={selectedExpert} refetch={refetch} />;
    default:
      return null;
  }
});

TabContent.displayName = 'TabContent';

TabContent.propTypes = {
  activeTab: PropTypes.number.isRequired,
  query: PropTypes.object.isRequired,
  refetch: PropTypes.func.isRequired,
  selectedExpert: PropTypes.object,
  setSelectedExpert: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  handleExpertDirectoryClick: PropTypes.func.isRequired,
};

export default TabContent;
